import React from 'react'
import MicroFrontend from "../MicroFrontend"
import MicroFrontendContainer from './MicroFrontendContainer'

const SideBannerWidget = ({ data }) => {

    return (
        <MicroFrontendContainer
            MicroFrontend={MicroFrontend}
            name="SideBannerWidget"
            data={data}
            height="264.31px"
            skeletonId="sideBannerWidgetSkeleton"
            refresh={false}
            className='sideBanner-container'
        />
    )
}

export default (SideBannerWidget);
